<template>
  <div id="app-pricer">
    <div class="nb-wiz-choices sub-line blue-box-x2"> 
            {{ $t('title') }}<br><br>
        <div>
                <div class="vue-slider-div">
                    <vue-slider ref="slider1" 
                        v-model="sliderValue"
                        :min="0"
                        :max="2000" 
                        :interval="sliderInterval"
                        v-on:callback="setSliderIntervalEstimatePage">
                    </vue-slider>
                    
                </div>
            <div class="server-pro-pricing-txt" v-if="country == 'DNK'" >{{ sliderValue }} {{ $t('gb_for') }} {{currencySymbol}}{{ formatCurrency(calculateProPrice(sliderValue), currencySymbol) }} {{ $t('per_month') }}</div>
            <div class="server-pro-pricing-txt" v-if="country == 'USA'" >{{ sliderValue }} {{ $t('gb_for') }} {{currencySymbol}}{{ formatCurrency(calculateProPrice(sliderValue), currencySymbol) }} per month </div>
            <div class="server-pro-pricing-txt-sub" v-if="country == 'USA'" >*each GB over 2TB is 11&cent; </div>  
            <div class="server-pro-pricing-txt-sub" v-if="country == 'DNK'">{{ $t('gigs_over_xxx') }} </div>
        </div>
    </div>
  </div>
  
</template>

<script>
Number.prototype.format = function(n, x) {
    
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');

};

import vueSlider from 'vue-slider-component';

export default {
  name: 'app-pricer',
  components: {vueSlider },
  data () {
    return {
      sliderValue: 10,
      sliderInterval: 10,
      country: '',
      minimumProPrice: 0,
      currencySymbol: '',
      language: 'en'
    }
  },
  methods: {
     setSliderIntervalEstimatePage(){
          
         /* if (this.sliderValue > 1000){
              this.sliderInterval = 1000;
          } else { 
              this.sliderInterval = 50;
          }*/
      },
      getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    },
    getUrlParam(parameter, defaultvalue){
        var urlparameter = defaultvalue;
        if(window.location.href.indexOf(parameter) > -1){
            urlparameter = this.getUrlVars()[parameter];
            }
        return urlparameter;
    },
    formatCurrency(amount, cur, prod_cat = '') {
        var n = 2;
        var amt = 0;
         
        amount = String(amount).replace(',', '');
         
        if (cur == "$"){
            amt = Number(amount).format(2);
        } else {
            //console.log('amount: '+amount);
            // since number are pre-formated for usa currency take out the commas to avoid Nan error.
            
            // define regex
            var re = '\\d(?=(\\d{' + 3 + '})+' + (n > 0 ? '\\.' : '$') + ')';
            
            // format number
            if (String(amount).indexOf('.') == -1){
                // if there's no decimal format it
                amt = Number(amount).toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
            } else {
                // with decimal make sure it's formated with commas
                var amt_str = String(amount);
                var cents = '00';
                if (amt_str.indexOf(',') == -1 && amt_str.length > 6){
                    // does it have cents?
                    if (Number(amt_str.substr(-2, amt_str.length)) > 0){
                        cents = amt_str.substr(-2, amt_str.length);
                    }
                    amt_str = amt_str.substr(0, (amt_str.length - 3));
                    
                    amt = Number(amt_str).toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
                    
                    amt = String(amt);
                    // ok add the cents back in if any
                    amt = amt.substr(0, (amt.length - 3)) +'.'+cents;
                } else {
                    amt = amount;
                }
            }
            
            // replace commas with dots
            amt = String(amt);
            amt = amt.replace(/,/g, '.');
            
            // replace decimal with comma
            // if there are 'cents' put them, otherwise use shorthand ,-
            if (Number(amt.substr(-2, amt.length)) > 0){
                amt = amt.substr(0, (amt.length - 3)) +','+amt.substr(-2, amt.length);
            } else {
                amt = amt.substr(0, (amt.length - 3)) +',-';
            }
            
            //console.log(amt);
            
            amt = amt;
        }
         // Some Options when displaying products
         if (prod_cat == 'home' && this.country == 'USA'){
             // in products
             return amt + '/yr' 
         } else if (prod_cat == 'biz' && this.country == 'USA'){
             // in products
             return amt + '/yr' 
         }  else if ((prod_cat == 'home' && this.country == 'DNK') || (prod_cat == 'home' && this.country == 'NOR')){
             // in products
             return amt + '/year incl. sales tax' 
         } else if ((prod_cat == 'personal' && this.country == 'DNK') || (prod_cat == 'home' && this.country == 'NOR')){
             // in addons
             return amt; // + ' incl. sales tax' 
         } else if ((prod_cat == 'biz' && this.country == 'DNK') || (prod_cat == 'home' && this.country == 'NOR')){
             // in products
             return amt + '/year excl. sales tax' 
         } else if ((prod_cat == 'bigBiz' && this.country == 'DNK') || (prod_cat == 'smallBiz' && this.country == 'DNK') || 
                    (prod_cat == 'bigBiz' && this.country == 'NOR') || (prod_cat == 'smallBiz' && this.country == 'NOR')){
             // in addons
             return amt; // + ' excl. sales tax' 
         } else {
             return amt;
         }

      },
      calculateProPrice(amount) {
        var res = 0;
        
        if (this.country == 'USA'){
            this.minimumProPrice = 21;
            if (amount > 2000) { 
                res =  amount * 0.11 + 438.35;}  
            else if (amount > 500) { 
                res =  amount * 0.22 + 218.35;}  
            else if (amount > 250) { 
                res =  amount * 0.55 + 53.35;}  
            else if (amount > 139) {
                res =  amount * 0.28 + 122.1;}  
            else if (amount > 129) { 
                res =  amount * 0.55 + 83.88;}  
            else if (amount > 100) { 
                res =  amount * 0.83 + 48.4;}  
            else if (amount > 30) { 
                res =  amount * 1.1 + 20.9;}  
            else if (amount > 10) { 
                res =  amount * 1.65 + 4.4;}  
            else if (amount > 5) { 
                res =  amount * 1.93 + 1.65;}   
            else if (amount > 0) { 
                res =  amount * 0 + 11;}
        } else if (this.country == 'DNK') {
            if (amount > 500) { 
                res =  amount * 1.1 + 1375;}
            else if (amount > 249) { 
                res =  amount * 3.3 + 274;}
            else if (amount > 129) { 
                res =  amount * 2.2 + 550;}
            else if (amount > 119) { 
                res =  amount * 3.3 + 407;}
            else if (amount > 99) { 
                res =  amount * 4.4 + 275;}
            else if (amount > 29) { 
                res =  amount * 5.5 + 165;}
            else if (amount > 9) { 
                res =  amount * 11 + 0;}
            else if (amount > 1) { 
                res =  amount * 9.9 + 12.1;}
            else if (amount > 0) { 
                res =  amount * 21 + 0;}


        }
        if (res < this.minimumProPrice){
            res = this.minimumProPrice;
        }
        return res;
     },
  },
  mounted() {
    this.language = this.getUrlParam('lang','da');
    // set currency symbol and country from functions.php
    // set in wordPress short code
    this.country = country;
    this.currencySymbol = currencySymbol;


    if (this.country == 'USA'){
        this.$i18n.locale = 'en';
    } else {
        this.$i18n.locale = this.language;
    }
    
  }
}
</script>

<style lang="scss">

#app-pricer {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2372AB;
}
.nb-wiz-choices{
		margin-left: 5px;
		font-size: 1em;
		display: block;
    padding-top: 40px;
    line-height: 1.6em;
	}
  .sub-line{

        background-color: #ffffff;
        border: #2372AB thin solid;
        padding: 10px;
        text-align: center;
		    font-size: 1.1em;
		    margin-bottom: 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding-top: 30px;
	}
    .vue-slider-div {
        padding: 10px 30px 10px 30px;
    }
    .server-pro-pricing-txt{
        font-size: 1em;
        line-height: 1.6em;
    }
    .server-pro-pricing-txt-sub{
        margin-top: 0px;
        font-size: .9em;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue